import { UserIcon } from '@heroicons/react/24/outline';
import React, { useState } from 'react';

import { useGetProfilePictureUrl } from '@/hooks/profilePicture';

interface Props {
  email: string;
  className?: string;
  isOrganization?: boolean;
}

const Avatar: React.FC<Props> = ({
  email,
  className,
  isOrganization = false,
}: Props) => {
  const [imageLoadError, setImageLoadError] = useState(false);
  const { data: profilePictureUrl } = useGetProfilePictureUrl({
    email,
    isOrganization,
  });

  return (
    <>
      {profilePictureUrl && !imageLoadError ? (
        <img
          src={profilePictureUrl.url}
          onError={() => setImageLoadError(true)}
          alt="User Avatar"
          className={className}
        />
      ) : (
        <div className="relative flex size-full items-center justify-center rounded-[2px] text-sm font-medium ring-inset focus:z-10 focus:outline-0">
          <UserIcon className="size-5 text-lg" />
        </div>
      )}
    </>
  );
};

export default Avatar;
